/**
 * @description This method creates object mirroring the key and values
 *
 * @param arr Array of strings
 * @returns object with mirror keys generated from the array of strings
 */
export const reflectKeys = (arr: string[] = []): Record<string, string> =>
  arr.reduce(
    (obj, key) => {
      const value = key.toUpperCase();
      obj[value] = value;

      return obj;
    },
    {} as Record<string, string>,
  );
